/* tslint:disable */
/* eslint-disable */
/**
 * The Thing API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface Question
 */
export interface Question {
    /**
     * 
     * @type {number}
     * @memberof Question
     */
    interrogatoryId?: number | null;
    /**
     * 
     * @type {string}
     * @memberof Question
     */
    text?: string | null;
    /**
     * 
     * @type {number}
     * @memberof Question
     */
    number?: number;
    /**
     * 
     * @type {string}
     * @memberof Question
     */
    questionId?: string | null;
}

export function QuestionFromJSON(json: any): Question {
    return QuestionFromJSONTyped(json, false);
}

export function QuestionFromJSONTyped(json: any, ignoreDiscriminator: boolean): Question {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'interrogatoryId': !exists(json, 'interrogatoryId') ? undefined : json['interrogatoryId'],
        'text': !exists(json, 'text') ? undefined : json['text'],
        'number': !exists(json, 'number') ? undefined : json['number'],
        'questionId': !exists(json, 'questionId') ? undefined : json['questionId'],
    };
}

export function QuestionToJSON(value?: Question | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'interrogatoryId': value.interrogatoryId,
        'text': value.text,
        'number': value.number,
        'questionId': value.questionId,
    };
}


